import React, { useEffect, useRef } from "react";
import { Copy, Scissors, ClipboardPaste, ArrowDownToLine, Eraser, Plus, Files, Trash2 } from "lucide-react";

const ITEMS = [
  { a: "copy", label: "Copy", icon: Copy, kbd: "Ctrl+C" },
  { a: "cut", label: "Cut", icon: Scissors, kbd: "Ctrl+X", edit: true },
  { a: "paste", label: "Paste", icon: ClipboardPaste, kbd: "Ctrl+V", edit: true },
  { a: "fill_down", label: "Fill down", icon: ArrowDownToLine, kbd: "Ctrl+D", edit: true },
  { a: "clear", label: "Clear cells", icon: Eraser, kbd: "Del", edit: true },
  { sep: true },
  { a: "insert_above", label: "Insert row above", icon: Plus, edit: true },
  { a: "insert_below", label: "Insert row below", icon: Plus, edit: true },
  { a: "duplicate", label: "Duplicate row(s)", icon: Files, edit: true },
  { a: "delete", label: "Delete row(s)", icon: Trash2, edit: true, danger: true },
];

export const GridContextMenu = ({ x, y, onClose, onAction, readOnly, hasRange }) => {
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    window.addEventListener("mousedown", close); window.addEventListener("scroll", onClose, true);
    return () => { window.removeEventListener("mousedown", close); window.removeEventListener("scroll", onClose, true); };
  }, [onClose]);
  const left = Math.min(x, window.innerWidth - 230), top = Math.min(y, window.innerHeight - 330);
  return (
    <div ref={ref} style={{ left, top }} className="fixed z-[100] w-56 rounded-lg border bg-white shadow-xl py-1 text-sm animate-in fade-in-0 zoom-in-95" data-testid="grid-context-menu">
      {ITEMS.map((it, i) => it.sep ? <div key={i} className="my-1 border-t" /> : (
        <button key={it.a} disabled={!hasRange || (it.edit && readOnly)} onMouseDown={e => e.stopPropagation()} onClick={() => onAction(it.a)}
          className={`w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-slate-100 disabled:opacity-40 disabled:hover:bg-transparent ${it.danger ? "text-red-600" : "text-slate-700"}`}
          data-testid={`ctx-${it.a}`}>
          <it.icon className="w-3.5 h-3.5" /> <span className="flex-1">{it.label}</span>{it.kbd && <span className="text-[10px] text-slate-400">{it.kbd}</span>}
        </button>
      ))}
    </div>
  );
};
